import { Trans } from "@lingui/macro"
import * as A from "./atoms"

const termsLink = "https://pora.ai/terms/"
const privacyLink = "https://pora.ai/privacy-policy/"

export function TermsAndConditionsLink() {
	return (
		<A.AgreementsLink
			href={termsLink}
			// href={"https://glowbeweb.s3.us-east-2.amazonaws.com/glowbe_terms_web+NEW.pdf"}
			target="_blank"
			rel="noreferrer"
		>
			<Trans>Terms and Conditions</Trans>
		</A.AgreementsLink>
	)
}
export function PrivacyPolicyLink() {
	return (
		<A.AgreementsLink href={privacyLink} target="_blank" rel="noreferrer">
			<Trans>Privacy Policy</Trans>
		</A.AgreementsLink>
	)
}
export function CopyrightsText() {
	return (
		<A.Copyrights>
			{/* Copyright © 2019-2022 Pora. */}
			<Trans>Copyright © 2021-2023 Pora.</Trans>
			<br />
			<Trans>All rights reserved</Trans>
		</A.Copyrights>
	)
}

export function CopyrightsFooter() {
	return (
		<A.Footer>
			<A.AgreementsLinks>
				<TermsAndConditionsLink />
				<PrivacyPolicyLink />
			</A.AgreementsLinks>
			<CopyrightsText />
		</A.Footer>
	)
}
